import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react';

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';
import Settings from './Settings';
import Slider from 'react-rangeslider'
import {IconBrightness,IconOpacity,IconSaturation,IconContrast,IconBlur} from './Icons';

@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class Adjustment extends Component {

  @observable trans = {

  };

  @observable adjustment = {
    brightness : 0,
    contrast: 0,
    saturate : 0,
    stackblur: 0,
    opacity: 100,
  }

  adjustmentsConfig = [];
  @observable idLayer = null;

  sliderTimeout = null;

  constructor(props) {

    super(props);

    this.trans = this.props.dictionaryStorage.getCurrentLangDict;

    let scope = this;

    this.adjustmentsConfig = [
      {name:'opacity',icon:'fa-sun-o',component:'IconOpacity',text:this.t('Opacity'),start: 100,min: 0,max: 100},
      {name:'brightness',icon:'fa-sun-o',component:'IconBrightness',text:this.t('Brightness'),start: 0,min: -100,max: 100},
      {name:'contrast',icon:'fa-dot-circle-o',component:'IconContrast',text:this.t('Contrast'),start: 0,min: -100,max: 100},
      {name:'saturate',icon:'fa-crop',component:'IconSaturation',text:this.t('Saturation'),start: 0,min: -100,max: 100},
      {name:'stackblur',icon:'fa-arrows-v',component:'IconBlur',text:this.t('Blur'),start: 0,min: 0,max: 30},
    ];

    this.checked = this.props.checked;

    $(window).on('WorkArea-selectCanvasElem',(e,active)=>{

      var filters = [];

      if ( this.props.idLayer !== active.idLayer && this.props.idLayer !== undefined ) return;

      this.setAdjustment(active);
    })



    $(window).on('bf-transform',(e,obj)=>{

      if ( this.props.idLayer === obj.idLayer) {
        this.adjustment[obj.action] = obj.value;
      }

      if (  !this.props.idLayer ){
        // todo: test by id? Settings.getSettingsCurrentElementInstance.idLayer
        this.adjustment[obj.action] = obj.value;
      }

    });

  }

  //todo: set Adjustment on change props - not need now

  componentWillMount(){
   if ( this.props.layer )
   {
     this.setAdjustment(this.props.layer.instance);
   }
   else {
     this.setAdjustment(Settings.getSettingsCurrentElementInstance)
   }
  }

  setAdjustment(layer){

    for ( var key in this.adjustment ){
      if ( key === 'opacity' )
      {
        if ( layer.opacity ) {
          this.adjustment[key] =layer.opacity * 100;
        }
      }
      else
      for ( var j in layer.filters )
      {
        if (  layer.filters[j] && layer.filters[j][key] != undefined )
        {
          let val = layer.filters[j][key];
          this.adjustment[key] = val;
        }
      }
    }
  }

  resetAdjustment(){
    $(window).trigger('ShowLoaderTransition','a2');
    var obj = {};
    obj.action = 'reset-image-filters';
    obj.idLayer = this.props.idLayer;
    $(window).trigger('bf-transform',obj);

    for ( let i in this.adjustmentsConfig ){
      let k = this.adjustmentsConfig[i].name;
      let start = this.adjustmentsConfig[i].start;
      this.adjustment[k] = start;
    }

    $(window).trigger('HideLoader','a1+');
  }

  handleScroll(val,name){

    this.adjustment[name] = val;
  }

  handleScrollComplete(name){

    clearTimeout(this.sliderTimeout);
    this.sliderTimeout = setTimeout(()=>{
        $(window).off('FinishFilterAdjustment');

        $(window).on('FinishFilterAdjustment',function(){
        $(window).trigger('HideLoader','a1');

      });
      $(window).trigger('ShowLoaderTransition','a1');
      var obj = {};
      obj.idLayer = this.props.idLayer ? this.props.idLayer : Settings.getSettingsCurrentElementInstance.idLayer ;
      obj.value = this.adjustment[name];
      obj.action = name;

      setTimeout(function(){$(window).trigger('bf-transform',obj);},100);
    },400);

  }

  render() {

    const t = this.t;

    let adjustments = []
    _.map(this.adjustmentsConfig,(val,key)=>{
      _.map(this.props.show,(val2,key2)=>{
        if ( val.name == val2 )
        {
          adjustments.push(val);
        }
      })
    })


    const componentsList = {
      IconBrightness: <IconBrightness/>,
      IconOpacity: <IconOpacity/>,
      IconSaturation: <IconSaturation/>,
      IconContrast: <IconContrast/>,
      IconBlur:<IconBlur/>,
    }

    let style = {
      width: 120
    }

    this.props.width ? style.width = this.props.width : 120;

    return (
        <div className={"AdjustmentBody "+(this.props.inToolbar ? 'AdjustmentBody-inToolbar' : '')}>
          {
            _.map(adjustments, (adjustment, key) => {
              const IconTag = componentsList[adjustment.component];

              return (
                <div key={key} className="bf-adjust">
                  {
                    this.props.showIconWithText
                    &&
                    <span>{ IconTag } <span className="bf-adjust-title">{adjustment.text}</span></span>
                  }
                  <Slider
                    min={adjustment.min}
                    max={adjustment.max}
                    value={this.adjustment[adjustment.name]}
                    //onChangeStart={this.handleChangeStart}
                    onChange={ (val)=> { this.handleScroll(val,adjustment.name) } }
                    onChangeComplete={ ()=> { this.handleScrollComplete(adjustment.name) } }
                  />

                </div>
              )
            })
          }
          {
            this.props.showReset
            &&
            <div>
              <button onClick={ ()=> { this.resetAdjustment() } } className="reset-adjustment ">{t('Reset')} <svg width="16" height="13" viewBox="0 0 15.5 13.1"><path d="M9 0C5.4 0 2.5 2.9 2.5 6.5c0 0.4 0.1 0.9 0.1 1.3l-2-1.4L0 7.2l3.7 2.6 2.6-3.7L5.6 5.5 3.9 7.9C3.7 7.5 3.7 7 3.7 6.5c0-2.9 2.4-5.3 5.3-5.3s5.3 2.4 5.3 5.3 -2.4 5.3-5.3 5.3c-1 0-1.9-0.3-2.8-0.8L5.4 12c1 0.7 2.3 1.1 3.6 1.1 3.6 0 6.5-2.9 6.5-6.5C15.5 2.9 12.6 0 9 0z"/></svg></button>
            </div>
          }

        </div>

    );


  }
}


